<template>
  <div class="service-box">
    <div class="products-wrap">
      <div class="products-wrap-box">
        <!-- <div class="products-wrap-box__icon">icon here</div> -->
        <p class="products-wrap-box__name">{{content.name}}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ServiceBox",
  props: {
    content: {
      required: true,
      type: Object
    }
  },
  data() {
    return {
      data: ""
    };
  },
  mounted() {
    this.data = this.content;
  }
};
</script>

<style scoped lang="scss">
.products-wrap {
  text-align: center;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(120px, 120px));
  grid-gap: 20px;
  &-box {
    height: 120px;
    width: 120px;
    border-radius: 20px;
    box-shadow: 0 0 4px 0 rgba(213, 213, 213, 0.75);
    display: flex;
    justify-content: center;
    flex-direction: column;
  }
}
@media (min-width: 320px) {
  .service-box {
    margin-bottom: 20px;
  }
  .products-wrap-box {
    width: 115px;
  }
}
</style>